import { useCallback, useState } from 'react';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Button } from '@framework/ui/atoms/Button';
import { useTranslation } from 'react-i18next';
type Props = {
  isOpen: boolean;
  onClose(): void;
  onDelete(): void;
};

export const ViewsDeleteConfirmModal: React.FC<Props> = ({ isOpen, onClose, onDelete }: Props) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState<boolean>(false);

  const handleDelete = useCallback(() => {
    onDelete();
    setChecked(false);
    onClose();
  }, [onDelete, onClose]);

  const handleClose = useCallback(() => {
    setChecked(false);
    onClose();
  }, [onClose]);

  return (
    <GeneralModal
      isOpen={isOpen}
      submitButton={
        <Button color="danger" onClick={handleDelete} disabled={!checked}>
          {t('common.action.delete')}
        </Button>
      }
      cancelButton={
        <Button color="secondary" onClick={handleClose}>
          {t('common.action.cancel')}
        </Button>
      }
      onClose={handleClose}
      shouldCloseOnOverlayClick={false}
      title={t('canvas.viewDelete.title')}
    >
      <div className="p-4" style={{ width: '600px' }}>
        <p className={'pb-4'}>{t('canvas.viewDelete.description')}</p>
        <label className="block">
          <input
            type="checkbox"
            className="form-checkbox mr-1 size-6 border-brand"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          {t('canvas.viewDelete.checkLabel')}
        </label>
      </div>
    </GeneralModal>
  );
};
